import Notifi from "./Icons/Notifi";
import styled from "styled-components";

export default styled(Notifi)`
  margin-right: 40px;
`;
